import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Checklist from 'components/lib/checklist';
import { Channel } from 'models/search/search_filter';

function buildChannelOptions(t) {
  return [
    {
      id: Channel.CHAT_MESSAGE,
      label: t('Chat'),
    },
    {
      id: Channel.EMAIL,
      label: t('Email'),
    },
    {
      id: Channel.FB_COMMENT,
      label: t('Facebook Comment'),
    },
    {
      id: Channel.FB_MESSAGE,
      label: t('Facebook'),
    },
    {
      id: Channel.INSTAGRAM_COMMENT,
      label: t('Instagram Comment'),
    },
    {
      id: Channel.INSTAGRAM_DIRECT,
      label: t('Instagram Messaging'),
    },
    {
      id: Channel.PHONE_CALL,
      label: t('Phone'),
    },
    {
      id: Channel.SMS,
      label: t('SMS'),
    },
    {
      id: Channel.TWITTER,
      label: t('Twitter'),
    },
    {
      id: Channel.VOICEMAIL,
      label: t('Voicemail'),
    },
    {
      id: Channel.WHATSAPP,
      label: t('WhatsApp'),
    },
  ];
}

const ChannelFilter = function ({
  customChannels,
  isFbCommentEnabled,
  isFbMessengerEnabled,
  isChatEnabled,
  isInstagramCommentEnabled,
  isInstagramDirectEnabled,
  isWhatsAppEnabled,
  isTwitterEnabled,
  onChange,
  selectedChannels,
}) {
  const { t } = useTranslation();

  let customChannelOptions = customChannels.map(channel => {
    const channelId = `${Channel.CUSTOM_CHANNEL}:${channel.id}`;
    return { value: channelId, label: channel.name, isSelected: selectedChannels.indexOf(channelId) > -1 };
  });

  let options = buildChannelOptions(t)
    .filter(channel => isFbCommentEnabled || channel.id !== Channel.FB_COMMENT)
    .filter(channel => isFbMessengerEnabled || channel.id !== Channel.FB_MESSAGE)
    .filter(channel => isChatEnabled || channel.id !== Channel.CHAT_MESSAGE)
    .filter(channel => isInstagramCommentEnabled || channel.id !== Channel.INSTAGRAM_COMMENT)
    .filter(channel => isInstagramDirectEnabled || channel.id !== Channel.INSTAGRAM_DIRECT)
    .filter(channel => isWhatsAppEnabled || channel.id !== Channel.WHATSAPP)
    .filter(channel => isTwitterEnabled || channel.id !== Channel.TWITTER)
    .map(channel => {
      return { value: channel.id, label: channel.label, isSelected: selectedChannels.indexOf(channel.id) > -1 };
    })
    .concat(customChannelOptions)
    .sort((optionA, optionB) => optionA.label.localeCompare(optionB.label));

  return <Checklist onChange={onChannelChange} options={options} />;

  function onChannelChange(channel, isSelected) {
    let channels = isSelected ? _.union(selectedChannels, [channel]) : _.difference(selectedChannels, [channel]);
    onChange({ channels });
  }
};

ChannelFilter.propTypes = {
  customChannels: PropTypes.array,
  isChatEnabled: PropTypes.bool,
  isFbCommentEnabled: PropTypes.bool,
  isFbMessengerEnabled: PropTypes.bool,
  isInstagramCommentEnabled: PropTypes.bool,
  isInstagramDirectEnabled: PropTypes.bool,
  isWhatsAppEnabled: PropTypes.bool,
  isTwitterEnabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  selectedChannels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ChannelFilter;
